import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import AppHeader from './components/AppHeader.jsx';
import AppFooter from './components/AppFooter.jsx';
import CookieConsent from './components/CookieConsent.jsx';
import Landing from './pages/Landing.jsx';
import Home from './pages/Home.jsx';
import PodcastDetail from './pages/PodcastDetail.jsx';
import EpisodeDetail from './pages/EpisodeDetail.jsx';
import Leaderboard from './pages/Leaderboard.jsx';
import About from './pages/About.jsx';
import Contact from './pages/Contact.jsx';
import Privacy from './pages/Privacy.jsx';
import Methodology from './pages/Methodology.jsx';
import Analysis from './pages/Analysis.jsx';
import NotFound from './pages/NotFound.jsx';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

/**
 * Everything below the router.
 *
 * Kept separate from the router so the same tree can be mounted under
 * `BrowserRouter` in the browser (main.jsx) and `StaticRouter` in Node
 * (entry-server.jsx). Both must render identically or hydration will not match.
 */
export function AppShell() {
  return (
    <>
      <ScrollToTop />
      <AppHeader />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/podcasts" element={<Home />} />
          {/* Clean URL routes */}
          <Route path="/podcast/:podcastSlug" element={<PodcastDetail />} />
          <Route path="/podcast/:podcastSlug/episode/:episodeSlug" element={<EpisodeDetail />} />
          {/* Legacy UUID-based episode route — kept for backwards compat.
              Depends on a ?podcast_uuid= query string, so it is not prerendered. */}
          <Route path="/episode/:id" element={<EpisodeDetail />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          {/* Editorial pages. Registered in src/content/index.js, which also
              drives the sitemap and the prerender route list. */}
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/methodology" element={<Methodology />} />
          <Route path="/analysis/:slug" element={<Analysis />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <AppFooter />
      <CookieConsent />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  );
}
